import { createFileRoute } from '@tanstack/react-router';

import { DataSync } from '~/modules/dataSyncJobs/DataSync';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { routeParams } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/admin/data-sync')({
  component: DataSync,
  beforeLoad: createProtectedRoute({
    routePath: '/settings/admin/data-sync',
    ...routeParams,
  }),
});

export const DATA_SYNC_JOBS = buildRouteExport({
  Route,
  ...routeParams,
});
